import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class DutchPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Items per pagina:';
  override nextPageLabel = 'Volgende pagina';
  override previousPageLabel = 'Vorige pagina';
  override firstPageLabel = 'Eerste pagina';
  override lastPageLabel = 'Laatste pagina';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) return `0 van ${length}`;
    const totalPages = Math.ceil(length / pageSize);
    return `Pagina ${page + 1} van ${totalPages}`;
  };
}
